// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.

import { formatDob } from '../../api/format'
import type { PickedEntity } from './EntityPicker'

/**
 * CareRx wave-1 #1: who an enrollment surface is about. Carried WHOLE through selection and
 * reopen, never as a loose name string: the old `openReview(id, name?)` reopened after an edit
 * with no name and blanked the review panel's header. DOB sits next to the name on every
 * enrollment header so two patients with the same name cannot be confused.
 */
export interface PatientIdentity { id: string; name: string | null; dob: string | null }

/** An enrollment-queue row (or any row with the same three fields) as an identity. */
export function queueIdentity(row: { patient_id: string; patient_name: string | null; date_of_birth: string | null }): PatientIdentity {
  return { id: row.patient_id, name: row.patient_name, dob: row.date_of_birth }
}

/** "Name · DOB MM-DD-YYYY" — the DOB is a calendar date, rendered literally (no timezone shift). */
export function patientIdentityLabel(p: Pick<PatientIdentity, 'name' | 'dob'> | null | undefined, fallback = 'this patient'): string {
  return [p?.name?.trim() || fallback, p?.dob ? `DOB ${formatDob(p.dob)}` : null].filter(Boolean).join(' · ')
}

/** The EnrollmentDoor preset: its "Patient:" header renders `label`. */
export function identityPreset(p: PatientIdentity): PickedEntity {
  return { id: p.id, label: patientIdentityLabel(p) }
}
